import React from 'react';
import { Link } from 'react-router';
import Immutable from "immutable";
import {ROUTE_LEAGUE_PARTNER} from "../../constants/routeconstants";

export default class Footer extends React.Component {

    constructor(props) {
        super(props);
    }

    static propTypes = {
    };

    render() {

        return (
            <div className="page-footer">
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/src/components/misc/Footer.js